export function calcImpressions(installs: number, crPercent: number) {
  const I = Math.max(0, Number(installs) || 0);
  const CR = Math.min(100, Math.max(10, Number(crPercent) || 10)); // диапазон 10–100%
  // формула: показы = установки / (CR / 100)
  const impressions = Math.ceil(I / (CR / 100));
  return impressions - installs;
}
